import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Aloo from "../components/mainAloo/Aloo";
import HeaderSvg from "../components/HeaderSvg";

const MainAloo = () => {
  return (
    <AppWrapper>
      <HeaderSvg />
      <Header />
      <Aloo />
      <Footer />
    </AppWrapper>
  );
};

const AppWrapper = styled.div``;
export default MainAloo;
